/* Hatton Jewels customisations migrated from Be Yours 8.3.1 */
(function () {
  'use strict';

  var scheduled = false;

  function createWishlistLink() {
    var link = document.createElement('a');
    link.href = '#swym-wishlist';
    link.className = 'header__icon header__icon--wishlist focus-inset swym-wishlist';
    link.setAttribute('aria-label', 'Wishlist');
    link.setAttribute('data-hj-wishlist-link', '');
    link.innerHTML = '<svg class="icon icon-wishlist" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5S4 15.6 4 9.5A4.5 4.5 0 0 1 12 6.7a4.5 4.5 0 0 1 8 2.8c0 6.1-8 11-8 11Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path></svg><span class="visually-hidden">Wishlist</span>';
    return link;
  }



  function contactMarkup() {
    return '' +
      '<div class="hj-mobile-menu-contact" data-hj-mobile-menu-contact>' +
        '<div class="hj-mobile-menu-contact__intro"><h2>Get in touch</h2><p>Speak with our jewellery experts</p></div>' +
        '<div class="hj-mobile-menu-contact__links">' +
          '<a href="tel:+442031160069" class="hj-mobile-menu-contact__link">' +
            '<span class="hj-mobile-menu-contact__icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1.1-.3 1.2.4 2.4.6 3.7.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.7 21 3 13.3 3 3.8c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.7.1.4 0 .8-.3 1.1l-2.2 2.2z"></path></svg></span>' +
            '<span>Call Us</span><span class="hj-mobile-menu-contact__arrow" aria-hidden="true">→</span>' +
          '</a>' +
          '<a href="mailto:contact@hattonjewels.com" class="hj-mobile-menu-contact__link">' +
            '<span class="hj-mobile-menu-contact__icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><rect x="4" y="6" width="16" height="12" rx="1"></rect><path d="M4.5 7l7.5 6 7.5-6"></path></svg></span>' +
            '<span>Email Us</span><span class="hj-mobile-menu-contact__arrow" aria-hidden="true">→</span>' +
          '</a>' +
          '<a href="/pages/book-an-appointment" class="hj-mobile-menu-contact__link hj-mobile-menu-contact__link--primary">' +
            '<span class="hj-mobile-menu-contact__icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M7 3v3M17 3v3M4 8h16M5 5h14v16H5V5z"></path></svg></span>' +
            '<span>Book Appointment</span><span class="hj-mobile-menu-contact__arrow" aria-hidden="true">→</span>' +
          '</a>' +
        '</div>' +
      '</div>';
  }

  function insertMobileContact() {
    document.querySelectorAll('header-drawer').forEach(function (headerDrawer) {
      var drawer = headerDrawer.querySelector('.menu-drawer__navigation-container') ||
        headerDrawer.querySelector('.menu-drawer__inner-container') ||
        headerDrawer.querySelector('.menu-drawer');

      if (!drawer || drawer.querySelector('[data-hj-mobile-menu-contact]')) return;

      var wrapper = document.createElement('div');
      wrapper.innerHTML = contactMarkup();
      var contact = wrapper.firstElementChild;
      var utilityLinks = drawer.querySelector('.menu-drawer__utility-links');

      if (utilityLinks && utilityLinks.parentNode) {
        utilityLinks.parentNode.insertBefore(contact, utilityLinks);
      } else {
        drawer.appendChild(contact);
      }
    });
  }

  function hideSwymFloatingLauncher() {
    [
      '#swym-anchor',
      'a#notepad-anchor-title',
      '.swym-floating-launcher',
      '.swym-floating-button',
      '.swym-wishlist-floating-button',
      '.swym-notepad-link'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        if (!element.closest('.header__right')) {
          element.style.setProperty('display', 'none', 'important');
          element.style.setProperty('visibility', 'hidden', 'important');
          element.style.setProperty('opacity', '0', 'important');
          element.style.setProperty('pointer-events', 'none', 'important');
        }
      });
    });
  }

  function applyCustomisations() {
    scheduled = false;
    insertMobileContact();
    hideSwymFloatingLauncher();
  }

  function scheduleCustomisations() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(applyCustomisations);
  }

  scheduleCustomisations();
  document.addEventListener('DOMContentLoaded', scheduleCustomisations);
  window.addEventListener('load', scheduleCustomisations);
  window.addEventListener('resize', scheduleCustomisations);
  document.addEventListener('click', function (event) {
    if (event.target.closest('header-drawer summary')) {
      window.setTimeout(scheduleCustomisations, 50);
    }
  });

  new MutationObserver(scheduleCustomisations).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
